import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ModulosAnaliticosService, AnaliseCartaoCreditoResultado } from '../../core/services/modulos-analiticos.service';

interface SubModuloAnalitico {
  codigo: string;
  titulo: string;
  descricao: string;
  status: 'Disponível' | 'Em evolução' | 'Planejado';
  icone: string;
}

interface GrupoAnalitico {
  codigo: string;
  titulo: string;
  icone: string;
  aberto: boolean;
  itens: SubModuloAnalitico[];
}

interface JurosBancariosForm {
  valorVeiculo: number | null;
  entrada: number | null;
  valorFinanciamento: number | null;
  valorIof: number | null;
  despesaCartorio: number | null;
  despesaGravame: number | null;
  comissaoOrigem: number | null;
  valorTotalFinanciado: number | null;
  valorParcela: number | null;
  numeroParcelas: number | null;
  taxaMensal: number | null;
  taxaAnual: number | null;
  cetMensal: number | null;
  cetAnual: number | null;
  dataAssinatura: string;
  dataPrimeiraParcela: string;
  dataUltimaParcela: string;
  multaMora: number | null;
  jurosMoraMensal: number | null;
  dataVencimento: string;
  dataPagamento: string;
  sistema: string;
}

interface ParcelaAmortizacao {
  numero: number;
  saldoInicial: number;
  fatorJs: number;
  jurosPercentual: number;
  juros: number;
  parcelaContrato: number;
  parcelaRecalculada: number;
  amortizacao: number;
  saldoFinal: number;
  jsInverso: number;
  diferencaParcela: number;
}

interface JurosBancariosResultado {
  baseCalculo: number;
  taxaMensalEfetiva: number;
  taxaAnualEfetiva: number;
  cetMensal: number;
  cetAnualEfetiva: number;
  parcelaContrato: number;
  parcelaRecalculada: number;
  diferencaMensal: number;
  diferencaTotalNominal: number;
  totalContrato: number;
  totalRecalculado: number;
  totalJurosContrato: number;
  totalJurosRecalculado: number;
  totalJurosTabela: number;
  totalAmortizado: number;
  saldoFinal: number;
  diasAtraso: number;
  multaValor: number;
  jurosMoraValor: number;
  valorParcelaAtualizada: number;
  totalJurosLinear: number;
  totalJs: number;
  parcelas: ParcelaAmortizacao[];
  achados: string[];
  resumo: string;
}


interface ConsignadoForm {
  valorCapital: number | null;
  valorParcela: number | null;
  numeroParcelas: number | null;
  taxaMensal: number | null;
  taxaAnual: number | null;
  cetMensal: number | null;
  cetAnual: number | null;
  dataAssinatura: string;
  dataBase: string;
  dataPrimeiraParcela: string;
  dataUltimaParcela: string;
  diasCarencia: number | null;
  jurosCarenciaPercentual: number | null;
  sistema: string;
}

interface ParcelaConsignado {
  numero: number;
  saldoInicial: number;
  juros: number;
  amortizacao: number;
  parcela: number;
  saldoFinal: number;
  fator: number;
  diferencaParcela: number;
}

interface ConsignadoResultado {
  valorCapital: number;
  jurosCarencia: number;
  saldoPosCarencia: number;
  parcelaContrato: number;
  parcelaRecalculada: number;
  diferencaMensal: number;
  diferencaTotal: number;
  taxaMensal: number;
  taxaAnualEfetiva: number;
  cetMensal: number;
  cetAnualEfetiva: number;
  totalContrato: number;
  totalRecalculado: number;
  totalJurosContrato: number;
  totalJurosRecalculado: number;
  parcelas: ParcelaConsignado[];
  achados: string[];
  resumo: string;
}


interface VerbasTrabalhistasForm {
  salarioBase: number | null;
  dataAdmissao: string;
  dataDemissao: string;
  tipoRescisao: string;
  diasSaldoSalario: number | null;
  avisoPrevioDias: number | null;
  feriasVencidas: boolean;
  feriasProporcionaisAvos: number | null;
  decimoTerceiroAvos: number | null;
  fgtsSaldoInformado: number | null;
  considerarMultaFgts: boolean;
}

interface VerbasTrabalhistasResultado {
  saldoSalario: number;
  avisoPrevio: number;
  decimoTerceiro: number;
  feriasVencidasValor: number;
  feriasProporcionais: number;
  tercoFerias: number;
  baseFgtsEstimada: number;
  fgtsEstimado: number;
  multaFgts: number;
  totalBruto: number;
  totalComFgts: number;
  achados: string[];
  resumo: string;
}

interface HorasExtrasForm {
  salarioBase: number | null;
  jornadaMensal: number | null;
  horas50: number | null;
  horas100: number | null;
  adicionalNoturnoHoras: number | null;
  dsrPercentual: number | null;
  reflexosPercentual: number | null;
}

interface HorasExtrasResultado {
  valorHora: number;
  horas50Valor: number;
  horas100Valor: number;
  adicionalNoturnoValor: number;
  totalHoras: number;
  dsr: number;
  reflexos: number;
  totalGeral: number;
  achados: string[];
  resumo: string;
}


interface AcertoResumoFinal {
  id_funcionario: number;
  nome: string;
  dias_aviso: number;
  competencia_projetada_aviso: string;
  avos_13o_sem_projecao: number;
  avos_13o_com_projecao: number;
  avos_ferias_sem_projecao: number;
  avos_ferias_com_projecao: number;
  dias_mes: number;
  domingos_mes: number;
  feriados_mes: number;
  dias_descanso: number;
  dias_uteis_mes: number;
  hora_extra_50: number;
  hora_extra_100: number;
  dsr_sobre_he: number;
  adicional_noturno: number;
  comissao: number;
  evento_percentual: number;
  fgts_mensal: number;
  vr_fgts_aviso_previo: number;
  total_fgts: number;
  vr_saldo_salario: number;
  vr_aviso_previo: number;
  vr_13o_base: number;
  vr_reflexo_he_dsr_13o: number;
  vr_13o_total: number;
  vr_ferias_vencidas: number;
  vr_ferias_proporcionais_base: number;
  vr_reflexo_he_dsr_ferias: number;
  vr_ferias_proporcionais_total: number;
  vr_terco_ferias_base: number;
  vr_reflexo_he_dsr_terco: number;
  vr_terco_ferias_total: number;
  vr_multa_fgts: number;
  vr_total_bruto_rescisao: number;
  vr_inss: number;
  vr_irrf: number;
  vr_pensao: number;
  vr_total_descontos_rescisao: number;
  vr_total_liquido_rescisao: number;
}

interface AcertoMemoriaLong {
  id_funcionario: number;
  nome: string;
  competencia: string;
  verba: string;
  valor: number;
  fator_correcao: number;
  valor_corrigido: number;
}

interface AcertoDetalheMensal {
  id_funcionario: number;
  nome: string;
  competencia: string;
  tipo_evento: string;
  salario_base: number;
  hora_extra_50: number;
  hora_extra_100: number;
  dsr_sobre_he: number;
  fgts_mensal: number;
  vr_total_liquido_rescisao: number;
}


interface IndicadorValorAnalitico {
  codigo: string;
  nome: string;
  competencia: string | null;
  valor_percentual: number | null;
  fator_mensal: number | null;
  importado_em: string | null;
}

interface JurosAbusivosLinha {
  competencia: string;
  taxaIndicador: number;
  fatorIndicador: number;
  fatorIndiceAcumulado: number;
  fatorContratoAcumulado: number;
  valorPeloIndicador: number;
  valorPeloContrato: number;
  diferenca: number;
}

interface JurosAbusivosResultado {
  periodicidade: string;
  valorOriginal: number;
  valorPeloIndicador: number;
  valorPeloContrato: number;
  diferenca: number;
  percentualContratoSobreIndicador: number;
  avaliacao: string;
  linhas: JurosAbusivosLinha[];
}


interface TaxaBcbModalidadeValor {
  codigo: string;
  nome: string;
  competencia: string | null;
  taxa_mensal: number | null;
  taxa_anual: number | null;
  importado_em: string | null;
}

interface TaxaBcbReferencia {
  competencia: string;
  taxaMensal: number;
  taxaAnual: number;
  contratoSobreMedia: number;
  avaliacao: string;
}

@Component({
  selector: 'app-modulos-analiticos',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './modulos-analiticos.component.html',
  styleUrl: './modulos-analiticos.component.scss'
})
export class ModulosAnaliticosComponent {
  constructor(
    private readonly analiticosService: ModulosAnaliticosService,
    private readonly http: HttpClient,
    private readonly route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((params) => {
      const tela = params.get('tela');
      const codigo = this.codigoPorTela(tela);
      if (codigo) {
        this.moduloSelecionadoCodigo = codigo;
      }
    });
  }

  private codigoPorTela(tela: string | null): string | null {
    const mapa: Record<string, string> = {
      'dashboard': 'BANC_REVISAO_CONTRATO',
      'atualizacao-monetaria': 'CONT_ATUALIZACAO',
      'apuracao-contabil': 'CONT_APURACAO',
      'revisao-contrato-bancario': 'BANC_REVISAO_CONTRATO',
      'juros-bancarios': 'BANC_JUROS',
        'juros-abusivos-revisao-contratual': 'BANC_JUROS_ABUSIVOS',
      'consignado': 'BANC_CONSIGNADO',
      'credito-consignado': 'BANC_CONSIGNADO',
      'cartao-credito': 'BANC_CARTAO_CREDITO',
      'extratos-lancamentos': 'BANC_EXTRATOS',
      'acerto-rescisorio': 'TRAB_ACERTO_RESCISORIO',
      'acerto-trabalhista': 'TRAB_ACERTO_RESCISORIO',
      'verbas-trabalhistas': 'TRAB_VERBAS',
      'horas-extras': 'TRAB_HORAS',
      'avaliacao-sociedades': 'SOC_APURACAO_HAVERES',
      'area-tributaria': 'TRIB_CREDITOS',
      'recuperacao-judicial': 'RJ_CREDITOS',
      'pericia-atuarial': 'ATUARIAL_CALCULOS',
      'mediacao-arbitragem': 'ARB_QUADROS',
      'valuation': 'VAL_EMPRESAS'
    };

    return tela ? mapa[tela] || null : null;
  }
  menuTiposAberto = true;
  termoPesquisa = '';
  moduloSelecionadoCodigo = 'BANC_REVISAO_CONTRATO';

  jurosAbusivosForm: any = {
    tipoContrato: 'VEICULO_CDC',
    valorOriginal: 10000,
    valorBem: 50000,
    entrada: 10000,
    iof: 850,
    tarifaCadastro: 900,
    registroGravame: 350,
    seguroPrestamista: 1200,
    outrasDespesas: 0,
    qtdParcelas: 48,
    valorParcela: 1420,
    taxaAnualInformada: 79.59,
    cetMensalInformado: 5.4,
    cetAnualInformado: 88.14,
    dataInicial: '',
    dataFinal: '',
    taxaContratoMes: 5,
    indicador: 'SELIC_MENSAL',
    criterioAlerta: 150
  };

  jurosAbusivosCalculando = false;
  jurosAbusivosErro = '';
  jurosAbusivosResultado: JurosAbusivosResultado | null = null;
  taxaBcbVeiculosReferencia: TaxaBcbReferencia | null = null;



  jurosForm: JurosBancariosForm = {
    valorVeiculo: 30696,
    entrada: 5496,
    valorFinanciamento: 25200,
    valorIof: 476.32,
    despesaCartorio: null,
    despesaGravame: null,
    comissaoOrigem: null,
    valorTotalFinanciado: 25676.32,
    valorParcela: 685.15,
    numeroParcelas: 60,
    taxaMensal: 1.53,
    taxaAnual: 19.94,
    cetMensal: 1.77,
    cetAnual: 23.39,
    dataAssinatura: '2009-03-23',
    dataPrimeiraParcela: '2009-04-23',
    dataUltimaParcela: '2014-03-23',
    multaMora: 2.0,
    jurosMoraMensal: 1.0,
    dataVencimento: '',
    dataPagamento: '',
    sistema: 'FIXA_LINEAR'
  };

  jurosResultado: JurosBancariosResultado | null = null;

  consignadoResultado: ConsignadoResultado | null = null;
  consignadoForm: ConsignadoForm = {
    valorCapital: 22045.55,
    valorParcela: 518.50,
    numeroParcelas: 63,
    taxaMensal: 1.33,
    taxaAnual: 16.76,
    cetMensal: 1.30,
    cetAnual: 16.74,
    dataAssinatura: '2019-06-14',
    dataBase: '2019-07-14',
    dataPrimeiraParcela: '2019-08-01',
    dataUltimaParcela: '2024-10-01',
    diasCarencia: 18,
    jurosCarenciaPercentual: 0.75,
    sistema: 'CONSIGNADO_PRICE'
  };

  arquivoCartaoSelecionado: File | null = null;

  verbasResultado: VerbasTrabalhistasResultado | null = null;
  verbasForm: VerbasTrabalhistasForm = {
    salarioBase: 3200,
    dataAdmissao: '2022-01-10',
    dataDemissao: '2024-08-20',
    tipoRescisao: 'SEM_JUSTA_CAUSA',
    diasSaldoSalario: 20,
    avisoPrevioDias: 30,
    feriasVencidas: false,
    feriasProporcionaisAvos: 8,
    decimoTerceiroAvos: 8,
    fgtsSaldoInformado: null,
    considerarMultaFgts: true
  };

  horasResultado: HorasExtrasResultado | null = null;
  horasForm: HorasExtrasForm = {
    salarioBase: 3200,
    jornadaMensal: 220,
    horas50: 20,
    horas100: 6,
    adicionalNoturnoHoras: 0,
    dsrPercentual: 16.67,
    reflexosPercentual: 18.33
  };


  acertoAbaAtiva: 'resumo' | 'memoria' | 'detalhe' | 'achados' = 'resumo';
  acertoResumoFinal: AcertoResumoFinal[] = [];
  acertoMemoriaLong: AcertoMemoriaLong[] = [];
  acertoDetalheMensal: AcertoDetalheMensal[] = [];
  acertoAchados: string[] = [];

  resultadoCartao: AnaliseCartaoCreditoResultado | null = null;
  carregandoCartao = false;
  erroCartao = '';
  mensagemCartao = '';
  limiteLinhasCartao = 80;
  baixandoRelatorioCartao = false;

  grupos: GrupoAnalitico[] = [
    {
      codigo: 'CONTABIL',
      titulo: 'Perícia Contábil',
      icone: '📘',
      aberto: true,
      itens: [
        {
          codigo: 'CONT_ATUALIZACAO',
          titulo: 'Atualização Monetária',
          descricao: 'Correção por índices, juros, memória de cálculo e quadro demonstrativo.',
          status: 'Disponível',
          icone: '📈'
        },
        {
          codigo: 'CONT_APURACAO',
          titulo: 'Apuração Contábil',
          descricao: 'Organização de documentos, conciliação, saldos e diferenças contábeis.',
          status: 'Em evolução',
          icone: '🧾'
        }
      ]
    },
    {
      codigo: 'BANCARIA',
      titulo: 'Perícia Bancária',
      icone: '🏦',
      aberto: true,
      itens: [
        {
          codigo: 'BANC_REVISAO_CONTRATO',
          titulo: 'Revisão de Contrato Bancário',
          descricao: 'Análise de contrato, evolução do débito, taxa efetiva, encargos, tarifas e saldo apurado.',
          status: 'Disponível',
          icone: '📄'
        },
        {
          codigo: 'BANC_JUROS_ABUSIVOS',
          titulo: 'Juros Abusivos / Revisão Contratual',
          descricao: 'Análise preliminar de taxa contratual frente a indicadores econômicos, com memória de cálculo e indício técnico.',
          status: 'Disponível',
          icone: '⚖️'
        },
        {
          codigo: 'BANC_JUROS',
          titulo: 'Juros Bancários',
          descricao: 'Financiamento bancário, fixa linear, CET, taxa efetiva, parcela recalculada e memória de cálculo.',
          status: 'Disponível',
          icone: '💹'
        },
        {
          codigo: 'BANC_CONSIGNADO',
          titulo: 'Crédito Consignado',
          descricao: 'Contrato consignado, carência, juros proporcionais, parcela recalculada e evolução do saldo.',
          status: 'Disponível',
          icone: '💵'
        },
        {
          codigo: 'BANC_CARTAO_CREDITO',
          titulo: 'Cartão de Crédito',
          descricao: 'Upload e leitura da aba CARTÃO DE CRÉDITO - AJUSTADA, com exibição em grade para conferência.',
          status: 'Disponível',
          icone: '💳'
        },
        {
          codigo: 'BANC_EXTRATOS',
          titulo: 'Extratos e Lançamentos',
          descricao: 'Conferência de lançamentos, tarifas, duplicidades, amortizações e movimentações.',
          status: 'Em evolução',
          icone: '📑'
        }
      ]
    },
    {
      codigo: 'TRABALHISTA',
      titulo: 'Perícia Contábil na Justiça Trabalhista',
      icone: '⚖️',
      aberto: false,
      itens: [
        {
          codigo: 'TRAB_ACERTO_RESCISORIO',
          titulo: 'Acerto Rescisório KNIME',
          descricao: 'Conferência por saídas output_table_1, output_table_2 e output_table_3: cálculo mensal, memória longa e resumo final.',
          status: 'Disponível',
          icone: '📋'
        },
        {
          codigo: 'TRAB_VERBAS',
          titulo: 'Verbas Trabalhistas',
          descricao: 'Rescisão, saldo de salário, aviso, férias, 13º, FGTS e multa de 40%.',
          status: 'Disponível',
          icone: '🧮'
        },
        {
          codigo: 'TRAB_HORAS',
          titulo: 'Horas Extras',
          descricao: 'Hora normal, horas 50%/100%, DSR e reflexos demonstrativos.',
          status: 'Disponível',
          icone: '⏱️'
        }
      ]
    },
    {
      codigo: 'SOCIEDADES',
      titulo: 'Perícia em Avaliação de Sociedades',
      icone: '🏢',
      aberto: false,
      itens: [
        {
          codigo: 'SOC_APURACAO_HAVERES',
          titulo: 'Apuração de Haveres',
          descricao: 'Quadros de apoio para patrimônio, balanço especial, ajustes e haveres.',
          status: 'Em evolução',
          icone: '📊'
        }
      ]
    },
    {
      codigo: 'TRIBUTARIA',
      titulo: 'Perícia Contábil na Área Tributária',
      icone: '🏛️',
      aberto: false,
      itens: [
        {
          codigo: 'TRIB_CREDITOS',
          titulo: 'Créditos e Débitos Tributários',
          descricao: 'Análise de débitos, créditos, atualização, competência e composição tributária.',
          status: 'Planejado',
          icone: '🧾'
        },
        {
          codigo: 'TRIB_ISS',
          titulo: 'ISSQN / Serviços',
          descricao: 'Apoio para base de cálculo, competência, serviços e divergências fiscais.',
          status: 'Em evolução',
          icone: '🏙️'
        }
      ]
    },
    {
      codigo: 'RECUPERACAO',
      titulo: 'Perícia na Recuperação Judicial e Falência de Empresas',
      icone: '🏚️',
      aberto: false,
      itens: [
        {
          codigo: 'RJ_CREDITOS',
          titulo: 'Quadro de Credores',
          descricao: 'Análise de créditos, classificação, divergências e documentação de suporte.',
          status: 'Planejado',
          icone: '📚'
        }
      ]
    },
    {
      codigo: 'ATUARIAL',
      titulo: 'Tópicos de Perícia Atuarial',
      icone: '📐',
      aberto: false,
      itens: [
        {
          codigo: 'ATUARIAL_CALCULOS',
          titulo: 'Cálculos Atuariais',
          descricao: 'Estrutura inicial para premissas, períodos, taxas e projeções.',
          status: 'Planejado',
          icone: '🧠'
        }
      ]
    },
    {
      codigo: 'ARBITRAGEM',
      titulo: 'Perícia, Mediação e Arbitragem Contábil',
      icone: '🤝',
      aberto: false,
      itens: [
        {
          codigo: 'ARB_QUADROS',
          titulo: 'Quadros para Arbitragem',
          descricao: 'Organização de evidências, critérios técnicos e resumo para apoio à decisão.',
          status: 'Planejado',
          icone: '📝'
        }
      ]
    },
    {
      codigo: 'VALUATION',
      titulo: 'Avaliação de Empresas - Valuation em Perícias',
      icone: '📈',
      aberto: false,
      itens: [
        {
          codigo: 'VAL_EMPRESAS',
          titulo: 'Valuation em Perícias',
          descricao: 'Premissas, fluxos, múltiplos, ajustes e quadros de apoio ao laudo.',
          status: 'Em evolução',
          icone: '💼'
        }
      ]
    }
  ];

  get todosItens(): SubModuloAnalitico[] {
    return this.grupos.flatMap((grupo) => grupo.itens);
  }

  get moduloSelecionado(): SubModuloAnalitico {
    return this.todosItens.find((item) => item.codigo === this.moduloSelecionadoCodigo) || this.todosItens[0];
  }

  get gruposFiltrados(): GrupoAnalitico[] {
    const termo = this.termoPesquisa.trim().toLowerCase();
    if (!termo) return this.grupos;

    return this.grupos
      .map((grupo) => ({
        ...grupo,
        aberto: true,
        itens: grupo.itens.filter((item) =>
          [grupo.titulo, item.titulo, item.descricao, item.status]
            .join(' ')
            .toLowerCase()
            .includes(termo)
        )
      }))
      .filter((grupo) => grupo.itens.length > 0);
  }

  alternarMenuTipos(): void {
    this.menuTiposAberto = !this.menuTiposAberto;
  }

  alternarGrupo(grupo: GrupoAnalitico): void {
    grupo.aberto = !grupo.aberto;
  }

  selecionarModulo(codigo: string): void {
    this.moduloSelecionadoCodigo = codigo;
  }




  aplicarExemploJurosAbusivos(tipo: string): void {
    if (!tipo) {
      return;
    }

    if (tipo === 'VEICULO_CDC') {
      this.preencherExemploJurosAbusivos();
      return;
    }

    if (tipo === 'CONSIGNADO') {
      this.carregarExemploConsignado();
      return;
    }
  }

  preencherExemploJurosAbusivos(): void {
    this.jurosAbusivosForm = {
      tipoContrato: 'VEICULO_CDC',
      valorOriginal: 43300,
      valorBem: 50000,
      entrada: 10000,
      iof: 850,
      tarifaCadastro: 900,
      registroGravame: 350,
      seguroPrestamista: 1200,
      outrasDespesas: 0,
      qtdParcelas: 48,
      valorParcela: 1420,
      taxaAnualInformada: 79.59,
      cetMensalInformado: 5.4,
      cetAnualInformado: 88.14,
      dataInicial: '2026-01-01',
      dataFinal: '2026-04-01',
      taxaContratoMes: 5,
      indicador: 'SELIC_MENSAL',
      criterioAlerta: 150
    };
    this.jurosAbusivosResultado = null;
    this.jurosAbusivosErro = '';
  }


  valorFinanciadoVeiculoRecalculado(): number {
    const f: any = this.jurosAbusivosForm;
    return (
      Number(f.valorBem || 0)
      - Number(f.entrada || 0)
      + Number(f.iof || 0)
      + Number(f.tarifaCadastro || 0)
      + Number(f.registroGravame || 0)
      + Number(f.seguroPrestamista || 0)
      + Number(f.outrasDespesas || 0)
    );
  }

  diferencaComposicaoVeiculo(): number {
    return Number(this.jurosAbusivosForm.valorOriginal || 0) - this.valorFinanciadoVeiculoRecalculado();
  }

  valorTotalParcelasVeiculo(): number {
    const f: any = this.jurosAbusivosForm;
    return Number(f.qtdParcelas || 0) * Number(f.valorParcela || 0);
  }

  taxaAnualEquivalenteContrato(): number {
    const taxaMes = Number(this.jurosAbusivosForm.taxaContratoMes || 0) / 100;
    if (!taxaMes) return 0;
    return (Math.pow(1 + taxaMes, 12) - 1) * 100;
  }

  diferencaTaxaAnualInformada(): number {
    const f: any = this.jurosAbusivosForm;
    return Number(f.taxaAnualInformada || 0) - this.taxaAnualEquivalenteContrato();
  }

  avaliacaoTaxaAnualInformada(): string {
    const f: any = this.jurosAbusivosForm;
    if (!Number(f.taxaAnualInformada || 0)) return 'Taxa anual não informada';
    const diff = Math.abs(this.diferencaTaxaAnualInformada());
    if (diff <= 0.10) return 'Taxa anual compatível com a taxa mensal';
    return 'Atenção: taxa anual informada difere da equivalente composta';
  }

  cetAnualEquivalenteContrato(): number {
    const f: any = this.jurosAbusivosForm;
    const cetMes = Number(f.cetMensalInformado || 0) / 100;
    if (!cetMes) return 0;
    return (Math.pow(1 + cetMes, 12) - 1) * 100;
  }

  diferencaCetAnualInformado(): number {
    const f: any = this.jurosAbusivosForm;
    return Number(f.cetAnualInformado || 0) - this.cetAnualEquivalenteContrato();
  }

  avaliacaoCetInformado(): string {
    const f: any = this.jurosAbusivosForm;
    if (!Number(f.cetMensalInformado || 0) || !Number(f.cetAnualInformado || 0)) {
      return 'CET mensal/anual não informado';
    }
    const diff = Math.abs(this.diferencaCetAnualInformado());
    if (diff <= 0.15) return 'CET anual compatível com o CET mensal';
    return 'Atenção: CET anual informado difere do CET equivalente composto';
  }

  usarValorRecalculadoComoBase(): void {
    const valor = this.valorFinanciadoVeiculoRecalculado();
    if (valor > 0) {
      this.jurosAbusivosForm.valorOriginal = Number(valor.toFixed(2));
    }
  }


  buscarTaxaBcbVeiculosParaContrato(): void {
    this.taxaBcbVeiculosReferencia = null;

    const dataContrato = this.jurosAbusivosForm.dataInicial;
    const taxaContratoMes = Number(this.jurosAbusivosForm.taxaContratoMes || 0);

    if (!dataContrato || !taxaContratoMes) return;

    this.http.get<TaxaBcbModalidadeValor[]>('/api/taxas-bcb/modalidades/VEICULOS_PF/valores?limite=1000').subscribe({
      next: dados => {
        const dataBase = new Date(dataContrato + 'T00:00:00');

        const candidatos = (dados || [])
          .filter(v => !!v.competencia && v.taxa_mensal !== null && v.taxa_mensal !== undefined)
          .filter(v => new Date(String(v.competencia) + 'T00:00:00') <= dataBase)
          .sort((a, b) => String(b.competencia).localeCompare(String(a.competencia)));

        const ref = candidatos[0];

        if (!ref || ref.taxa_mensal === null || ref.taxa_mensal === undefined) {
          return;
        }

        const taxaMensal = Number(ref.taxa_mensal || 0);
        const taxaAnual = Number(ref.taxa_anual || 0);
        const contratoSobreMedia = taxaMensal > 0 ? (taxaContratoMes / taxaMensal) * 100 : 0;

        let avaliacao = 'DENTRO DA FAIXA DE COMPARAÇÃO BCB';
        if (contratoSobreMedia >= 200) {
          avaliacao = 'INDÍCIO TÉCNICO FORTE DE TAXA ACIMA DA MÉDIA BCB';
        } else if (contratoSobreMedia >= 150) {
          avaliacao = 'INDÍCIO TÉCNICO DE TAXA ACIMA DA MÉDIA BCB';
        }

        this.taxaBcbVeiculosReferencia = {
          competencia: String(ref.competencia),
          taxaMensal,
          taxaAnual,
          contratoSobreMedia,
          avaliacao
        };
      },
      error: () => {
        this.taxaBcbVeiculosReferencia = null;
      }
    });
  }

  calcularJurosAbusivos(): void {
    if (this.jurosAbusivosForm?.tipoContrato === 'CONSIGNADO') {
      this.jurosAbusivosResultado = null;
      this.jurosAbusivosErro = '';
      return;
    }


    this.jurosAbusivosErro = '';
    this.jurosAbusivosResultado = null;

    const valorOriginal = Number(this.jurosAbusivosForm.valorOriginal || 0);
    const taxaContratoMes = Number(this.jurosAbusivosForm.taxaContratoMes || 0);
    const criterioAlerta = Number(this.jurosAbusivosForm.criterioAlerta || 150);
    const dataInicial = this.jurosAbusivosForm.dataInicial;
    const dataFinal = this.jurosAbusivosForm.dataFinal;
    const indicador = this.jurosAbusivosForm.indicador;

    if (!valorOriginal || valorOriginal <= 0) {
      this.jurosAbusivosErro = 'Informe o valor original do contrato.';
      return;
    }

    if (!dataInicial || !dataFinal) {
      this.jurosAbusivosErro = 'Informe a data inicial e a data final.';
      return;
    }

    if (new Date(dataInicial) > new Date(dataFinal)) {
      this.jurosAbusivosErro = 'A data inicial não pode ser maior que a data final.';
      return;
    }

    this.jurosAbusivosCalculando = true;

    this.http.get<IndicadorValorAnalitico[]>(`/api/indicadores/${indicador}/valores?limite=500`).subscribe({
      next: dados => {
        const inicio = new Date(dataInicial + 'T00:00:00');
        const fim = new Date(dataFinal + 'T23:59:59');

        const valores = (dados || [])
          .filter(v => !!v.competencia)
          .filter(v => {
            const d = new Date(String(v.competencia) + 'T00:00:00');
            return d >= inicio && d <= fim;
          })
          .sort((a, b) => String(a.competencia).localeCompare(String(b.competencia)));

        if (!valores.length) {
          this.jurosAbusivosCalculando = false;
          this.jurosAbusivosErro = 'Não foram encontrados valores do indicador para o período informado.';
          return;
        }

        const mesesPeriodo =
          (fim.getFullYear() - inicio.getFullYear()) * 12 +
          (fim.getMonth() - inicio.getMonth()) + 1;

        const periodicidade = valores.length > mesesPeriodo * 2 ? 'Diário' : 'Mensal';

        const taxaContratoPeriodo =
          periodicidade === 'Diário'
            ? Math.pow(1 + taxaContratoMes / 100, 1 / 30) - 1
            : taxaContratoMes / 100;

        let fatorIndiceAcumulado = 1;
        let fatorContratoAcumulado = 1;

        const linhas: JurosAbusivosLinha[] = valores.map(v => {
          const fatorIndicador = Number(v.fator_mensal || 1);
          const taxaIndicador = Number(v.valor_percentual || 0);

          fatorIndiceAcumulado *= fatorIndicador;
          fatorContratoAcumulado *= (1 + taxaContratoPeriodo);

          const valorPeloIndicador = valorOriginal * fatorIndiceAcumulado;
          const valorPeloContrato = valorOriginal * fatorContratoAcumulado;

          return {
            competencia: String(v.competencia),
            taxaIndicador,
            fatorIndicador,
            fatorIndiceAcumulado,
            fatorContratoAcumulado,
            valorPeloIndicador,
            valorPeloContrato,
            diferenca: valorPeloContrato - valorPeloIndicador
          };
        });

        const ultima = linhas[linhas.length - 1];
        const percentualContratoSobreIndicador =
          ultima.valorPeloIndicador > 0
            ? (ultima.valorPeloContrato / ultima.valorPeloIndicador) * 100
            : 0;

        const avaliacao =
          percentualContratoSobreIndicador > criterioAlerta
            ? 'INDÍCIO TÉCNICO DE EXCESSO'
            : 'DENTRO DO PARÂMETRO DEFINIDO';

        this.jurosAbusivosResultado = {
          periodicidade,
          valorOriginal,
          valorPeloIndicador: ultima.valorPeloIndicador,
          valorPeloContrato: ultima.valorPeloContrato,
          diferenca: ultima.diferenca,
          percentualContratoSobreIndicador,
          avaliacao,
          linhas
        };

        this.jurosAbusivosCalculando = false;
        this.buscarTaxaBcbVeiculosParaContrato();
      },
      error: () => {
        this.jurosAbusivosCalculando = false;
        this.jurosAbusivosErro = 'Não foi possível carregar os valores do indicador selecionado.';
      }
    });
  }


  classeAvaliacaoJurosAbusivos(): string {
    const avaliacao = this.jurosAbusivosResultado?.avaliacao || '';
    return avaliacao.includes('EXCESSO') ? 'alerta' : 'ok';
  }


  valorPelaMediaBcbVeiculos(): number {
    const r = this.jurosAbusivosResultado;
    const ref = this.taxaBcbVeiculosReferencia;

    if (!r || !ref) return 0;

    const taxa = Number(ref.taxaMensal || 0) / 100;
    const meses = r.linhas.length || 0;

    if (!taxa || !meses) return r.valorOriginal;

    return r.valorOriginal * Math.pow(1 + taxa, meses);
  }

  diferencaContratoMediaBcbVeiculos(): number {
    const r = this.jurosAbusivosResultado;
    if (!r) return 0;

    return r.valorPeloContrato - this.valorPelaMediaBcbVeiculos();
  }

  percentualContratoSobreMediaBcbValor(): number {
    const r = this.jurosAbusivosResultado;
    const valorBcb = this.valorPelaMediaBcbVeiculos();

    if (!r || !valorBcb) return 0;

    return (r.valorPeloContrato / valorBcb) * 100;
  }

  larguraBarraMediaBcbVeiculos(): number {
    const r = this.jurosAbusivosResultado;
    if (!r) return 0;

    const valorBcb = this.valorPelaMediaBcbVeiculos();

    const maior = Math.max(
      r.valorPeloIndicador || 0,
      valorBcb || 0,
      r.valorPeloContrato || 0
    );

    if (!maior) return 0;

    return Math.max(4, (valorBcb / maior) * 100);
  }

  larguraBarraIndicador(): number {
    const r = this.jurosAbusivosResultado;
    if (!r) return 0;

    const valorBcb = this.valorPelaMediaBcbVeiculos();

    const maior = Math.max(
      r.valorPeloIndicador || 0,
      valorBcb || 0,
      r.valorPeloContrato || 0
    );

    if (!maior) return 0;

    return Math.max(4, (r.valorPeloIndicador / maior) * 100);
  }

  larguraBarraContrato(): number {
    const r = this.jurosAbusivosResultado;
    if (!r) return 0;

    const valorBcb = this.valorPelaMediaBcbVeiculos();

    const maior = Math.max(
      r.valorPeloIndicador || 0,
      valorBcb || 0,
      r.valorPeloContrato || 0
    );

    if (!maior) return 0;

    return Math.max(4, (r.valorPeloContrato / maior) * 100);
  }


  valorBaseParcelaBcb(): number {
    const recalculado = this.valorFinanciadoVeiculoRecalculado();
    return recalculado > 0 ? recalculado : Number(this.jurosAbusivosForm.valorOriginal || 0);
  }

  calcularParcelaPriceBcb(valor: number, taxaMensalPercentual: number, prazoMeses: number): number {
    const taxa = Number(taxaMensalPercentual || 0) / 100;
    const prazo = Number(prazoMeses || 0);

    if (!valor || valor <= 0 || !prazo || prazo <= 0) return 0;

    if (!taxa) return valor / prazo;

    return valor * (taxa / (1 - Math.pow(1 + taxa, -prazo)));
  }

  parcelaBcbPorMultiplicador(multiplicador: number): number {
    const ref = this.taxaBcbVeiculosReferencia;
    if (!ref) return 0;

    const valor = this.valorBaseParcelaBcb();
    const prazo = Number(this.jurosAbusivosForm.qtdParcelas || 0);
    const taxa = Number(ref.taxaMensal || 0) * multiplicador;

    return this.calcularParcelaPriceBcb(valor, taxa, prazo);
  }

  parcelaMediaBcb(): number {
    return this.parcelaBcbPorMultiplicador(1);
  }

  parcelaBcbAtencao150(): number {
    return this.parcelaBcbPorMultiplicador(1.5);
  }

  parcelaBcbAlerta200(): number {
    return this.parcelaBcbPorMultiplicador(2);
  }

  percentualParcelaSobreMediaBcb(): number {
    const media = this.parcelaMediaBcb();
    const parcela = Number(this.jurosAbusivosForm.valorParcela || 0);

    if (!media) return 0;

    return (parcela / media) * 100;
  }

  avaliacaoParcelaBcb(): string {
    const percentual = this.percentualParcelaSobreMediaBcb();

    if (!percentual) return 'Informe valor da parcela e prazo para avaliar.';

    if (percentual < 100) {
      return 'Parcela abaixo da estimativa pela média BCB.';
    }

    if (percentual <= 150) {
      return 'Parcela dentro da faixa de atenção.';
    }

    if (percentual <= 200) {
      return 'Indício técnico de parcela elevada frente à média BCB.';
    }

    return 'Indício técnico forte de parcela acima da média BCB.';
  }

  classeAvaliacaoParcelaBcb(): string {
    const percentual = this.percentualParcelaSobreMediaBcb();

    if (!percentual) return 'neutro';
    if (percentual <= 150) return 'ok';
    if (percentual <= 200) return 'alerta';

    return 'forte';
  }




  aoAlterarTipoContrato(): void {
    this.jurosAbusivosResultado = null;
    this.jurosAbusivosErro = '';

    if (this.jurosAbusivosForm?.tipoContrato !== 'VEICULO_CDC') {
      this.taxaBcbVeiculosReferencia = null;
    }
  }

  carregarExemploConsignado(): void {
    this.jurosAbusivosForm = {
      ...this.jurosAbusivosForm,
      tipoContrato: 'CONSIGNADO',
      subtipoConsignado: 'CONSIGNADO_TOTAL_PF',
      valorOriginal: 62417.33,
      valorLiberadoConsignado: 62417.33,
      dataInicial: '2023-08-01',
      dataFinal: '2031-03-01',
      qtdParcelas: 92,
      valorParcela: 1306.32,
      taxaContratoMes: 1.54,
      taxaAnualInformada: 20.13,
      cetMensalInformado: 1.54,
      cetAnualInformado: 20.13,
      iof: 0,
      tarifaCadastro: 0,
      registroGravame: 0,
      seguroPrestamista: 0,
      outrasDespesas: 0,
      carenciaConsignado: 1,
      parcelasPagasConsignado: 34,
      competenciaBcbConsignado: '07/2023',
      taxaMediaBcbConsignadoMensal: 1.90,
      taxaMediaBcbConsignadoAnual: 25.35,
      fonteBcbConsignado: 'BCB/SGS - CONSIGNADO_TOTAL_PF - competência 07/2023',
      tipoReferenciaSecundariaConsignado: 'TETO_CNPS_INSS',
      competenciaReferenciaSecundariaConsignado: '07/2023',
      taxaReferenciaSecundariaConsignadoMensal: 1.97,
      taxaReferenciaSecundariaConsignadoAnual: 26.38,
      fonteReferenciaSecundariaConsignado: 'Teto CNPS/INSS vigente no período',

      indicador: 'SELIC_MENSAL',
      criterioAlerta: 150
    };

    this.jurosAbusivosResultado = null;
    this.taxaBcbVeiculosReferencia = null;
    this.jurosAbusivosErro = '';
  }

  valorBaseConsignado(): number {
    return Number(
      this.jurosAbusivosForm.valorLiberadoConsignado ||
      this.jurosAbusivosForm.valorOriginal ||
      0
    );
  }

  valorTotalParcelasConsignado(): number {
    return Number(this.jurosAbusivosForm.valorParcela || 0) *
      Number(this.jurosAbusivosForm.qtdParcelas || 0);
  }

  jurosTotaisAproximadosConsignado(): number {
    return this.valorTotalParcelasConsignado() - this.valorBaseConsignado();
  }

  parcelaMediaBcbConsignado(): number {
    const valor = this.valorBaseConsignado();
    const prazo = Number(this.jurosAbusivosForm.qtdParcelas || 0);
    const taxa = Number(this.jurosAbusivosForm.taxaMediaBcbConsignadoMensal || 0);

    if (!valor || !prazo || !taxa) return 0;

    return this.calcularParcelaPriceBcb(valor, taxa, prazo);
  }

  contratoSobreMediaBcbConsignado(): number {
    const taxaContrato = Number(this.jurosAbusivosForm.taxaContratoMes || 0);
    const taxaBcb = Number(this.jurosAbusivosForm.taxaMediaBcbConsignadoMensal || 0);

    if (!taxaContrato || !taxaBcb) return 0;

    return (taxaContrato / taxaBcb) * 100;
  }

  parcelaSobreMediaBcbConsignado(): number {
    const parcelaBcb = this.parcelaMediaBcbConsignado();
    const parcelaContrato = Number(this.jurosAbusivosForm.valorParcela || 0);

    if (!parcelaBcb) return 0;

    return (parcelaContrato / parcelaBcb) * 100;
  }



  isContratoVeiculo(): boolean {
    return this.jurosAbusivosForm?.tipoContrato === 'VEICULO_CDC';
  }

  isContratoConsignado(): boolean {
    return this.jurosAbusivosForm?.tipoContrato === 'CONSIGNADO';
  }

  textoLeituraConsignadoBcb(): string {
    const contrato = Number(this.jurosAbusivosForm?.taxaContratoMes || this.jurosAbusivosForm?.cetMensalInformado || 0);
    const media = Number(this.jurosAbusivosForm?.taxaMediaBcbConsignadoMensal || 0);
    const competencia = String(this.jurosAbusivosForm?.competenciaBcbConsignado || '').trim();
    const parcelaContrato = Number(this.jurosAbusivosForm?.valorParcela || 0);
    const parcelaMedia = Number(this.parcelaMediaBcbConsignado() || 0);

    const fmtPct = (v: number) =>
      v.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    const fmtMoeda = (v: number) =>
      v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

    if (!contrato || !media) {
      return 'Informe a taxa contratual mensal e busque a taxa média BCB da competência para gerar a leitura técnica do consignado.';
    }

    const relacaoTaxa = (contrato / media) * 100;
    const relacaoParcela = parcelaMedia > 0 ? (parcelaContrato / parcelaMedia) * 100 : 0;

    if (contrato <= media) {
      return `A taxa contratual mensal informada foi de ${fmtPct(contrato)}% a.m. A taxa média BCB da modalidade crédito pessoal consignado total - pessoa física, na competência ${competencia}, foi de ${fmtPct(media)}% a.m. Assim, a taxa do contrato corresponde a ${fmtPct(relacaoTaxa)}% da média BCB, ficando abaixo da referência observada para a modalidade. A prestação contratada de ${fmtMoeda(parcelaContrato)} também pode ser comparada com a prestação estimada pela média BCB, de ${fmtMoeda(parcelaMedia)}, correspondendo a ${fmtPct(relacaoParcela)}% dessa referência. Em leitura técnica preliminar, não há indício de taxa acima da média BCB informada.`;
    }

    return `A taxa contratual mensal informada foi de ${fmtPct(contrato)}% a.m. A taxa média BCB da modalidade crédito pessoal consignado total - pessoa física, na competência ${competencia}, foi de ${fmtPct(media)}% a.m. Assim, a taxa do contrato corresponde a ${fmtPct(relacaoTaxa)}% da média BCB, ficando acima da referência observada para a modalidade. Em leitura técnica preliminar, há indício de taxa superior à média BCB, sujeito à análise completa do contrato e dos encargos informados.`;
  }


  formatarTipoReferenciaSecundariaConsignado(): string {
    const tipo = String(this.jurosAbusivosForm?.tipoReferenciaSecundariaConsignado || '');

    const mapa: any = {
      TETO_CNPS_INSS: 'Teto CNPS/INSS',
      TETO_CONVENIO_ORGAO: 'Teto do convênio/órgão',
      REFERENCIA_DOCUMENTAL: 'Referência documental manual',
      OUTRA: 'Outra referência'
    };

    return mapa[tipo] || 'Segunda referência';
  }

  taxaReferenciaSecundariaConsignadoAnualCalculada(): number {
    const mensal = Number(this.jurosAbusivosForm?.taxaReferenciaSecundariaConsignadoMensal || 0);

    if (!mensal) {
      return Number(this.jurosAbusivosForm?.taxaReferenciaSecundariaConsignadoAnual || 0);
    }

    return (Math.pow(1 + mensal / 100, 12) - 1) * 100;
  }

  contratoSobreReferenciaSecundariaConsignado(): number {
    const contrato = Number(this.jurosAbusivosForm?.taxaContratoMes || this.jurosAbusivosForm?.cetMensalInformado || 0);
    const referencia = Number(this.jurosAbusivosForm?.taxaReferenciaSecundariaConsignadoMensal || 0);

    if (!contrato || !referencia) {
      return 0;
    }

    return (contrato / referencia) * 100;
  }

  parcelaReferenciaSecundariaConsignado(): number {
    const valor = this.valorBaseConsignado();
    const parcelas = Number(this.jurosAbusivosForm?.qtdParcelas || 0);
    const taxa = Number(this.jurosAbusivosForm?.taxaReferenciaSecundariaConsignadoMensal || 0);

    if (!valor || !parcelas || !taxa) {
      return 0;
    }

    const i = taxa / 100;
    return valor * (i / (1 - Math.pow(1 + i, -parcelas)));
  }

  parcelaSobreReferenciaSecundariaConsignado(): number {
    const parcelaRef = this.parcelaReferenciaSecundariaConsignado();
    const parcelaContrato = Number(this.jurosAbusivosForm?.valorParcela || 0);

    if (!parcelaRef || !parcelaContrato) {
      return 0;
    }

    return (parcelaContrato / parcelaRef) * 100;
  }

  textoLeituraConsignadoCompleta(): string {
    const contrato = Number(this.jurosAbusivosForm?.taxaContratoMes || this.jurosAbusivosForm?.cetMensalInformado || 0);
    const mediaBcb = Number(this.jurosAbusivosForm?.taxaMediaBcbConsignadoMensal || 0);
    const segundaRef = Number(this.jurosAbusivosForm?.taxaReferenciaSecundariaConsignadoMensal || 0);
    const competenciaBcb = String(this.jurosAbusivosForm?.competenciaBcbConsignado || '').trim();
    const competenciaSegunda = String(this.jurosAbusivosForm?.competenciaReferenciaSecundariaConsignado || competenciaBcb).trim();

    const fmtPct = (v: number) =>
      v.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    if (!contrato || !mediaBcb) {
      return 'Informe a taxa contratual mensal e busque a taxa média BCB da competência para gerar a leitura técnica do consignado.';
    }

    const relacaoBcb = (contrato / mediaBcb) * 100;

    let texto =
      `A taxa contratual/CET mensal informada foi de ${fmtPct(contrato)}% a.m. ` +
      `A taxa média BCB da modalidade crédito pessoal consignado total - pessoa física, na competência ${competenciaBcb}, foi de ${fmtPct(mediaBcb)}% a.m. ` +
      `Assim, a taxa do contrato corresponde a ${fmtPct(relacaoBcb)}% da média BCB. `;

    if (segundaRef) {
      const relacaoSegunda = (contrato / segundaRef) * 100;
      texto +=
        `Como segunda referência, foi utilizado ${this.formatarTipoReferenciaSecundariaConsignado()}, na competência ${competenciaSegunda}, com taxa de ${fmtPct(segundaRef)}% a.m. ` +
        `Nessa comparação, a taxa do contrato corresponde a ${fmtPct(relacaoSegunda)}% da segunda referência. `;
    }

    if (contrato <= mediaBcb && (!segundaRef || contrato <= segundaRef)) {
      texto +=
        'Em leitura técnica preliminar, a taxa contratual ficou abaixo das principais referências informadas para a modalidade.';
    } else if (contrato > mediaBcb && segundaRef && contrato <= segundaRef) {
      texto +=
        'Em leitura técnica preliminar, a taxa contratual ficou acima da média BCB, mas abaixo da segunda referência normativa/documental informada. A conclusão deve destacar a diferença entre referência de mercado e limite aplicável.';
    } else if (contrato <= mediaBcb && segundaRef && contrato > segundaRef) {
      texto +=
        'Em leitura técnica preliminar, a taxa contratual ficou abaixo da média BCB, mas acima da segunda referência normativa/documental informada. Recomenda-se verificar a aplicabilidade jurídica e contratual desse limite.';
    } else {
      texto +=
        'Em leitura técnica preliminar, há indício de taxa superior às referências informadas, sujeito à análise completa do contrato, encargos e metodologia aplicável.';
    }

    return texto;
  }

  normalizarCompetenciaBcbConsignado(): string {
    const valor = String(this.jurosAbusivosForm?.competenciaBcbConsignado || '').trim();

    if (!valor) {
      return '';
    }

    const mmAaaa = valor.match(/^(\d{2})\/(\d{4})$/);
    if (mmAaaa) {
      return `${mmAaaa[2]}-${mmAaaa[1]}-01`;
    }

    const aaaaMmDd = valor.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (aaaaMmDd) {
      return `${aaaaMmDd[1]}-${aaaaMmDd[2]}-01`;
    }

    const aaaaMm = valor.match(/^(\d{4})-(\d{2})$/);
    if (aaaaMm) {
      return `${aaaaMm[1]}-${aaaaMm[2]}-01`;
    }

    return valor;
  }


  async calcularAnaliseConsignadoJurosAbusivos(): Promise<void> {
    const valorBase = this.valorBaseConsignado();
    const parcela = Number(this.jurosAbusivosForm?.valorParcela || 0);
    const qtd = Number(this.jurosAbusivosForm?.qtdParcelas || 0);
    const taxaContrato = Number(this.jurosAbusivosForm?.taxaContratoMes || this.jurosAbusivosForm?.cetMensalInformado || 0);

    if (!valorBase || !parcela || !qtd || !taxaContrato) {
      this.jurosAbusivosForm.mensagemBcbConsignado =
        'Preencha valor liberado, valor da prestação, quantidade de prestações e taxa/CET mensal para calcular a análise do consignado.';
      return;
    }

    if (!this.jurosAbusivosForm?.taxaMediaBcbConsignadoMensal) {
      await this.buscarTaxaBcbConsignado();
    }

    const taxaBcb = Number(this.jurosAbusivosForm?.taxaMediaBcbConsignadoMensal || 0);

    if (!taxaBcb) {
      this.jurosAbusivosForm.mensagemBcbConsignado =
        'Dados do contrato conferidos, mas a taxa média BCB ainda não foi localizada para a competência informada.';
      return;
    }

    const contratoSobreBcb = this.contratoSobreMediaBcbConsignado();
    const parcelaSobreBcb = this.parcelaSobreMediaBcbConsignado();

    const pctContrato = contratoSobreBcb.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const pctParcela = parcelaSobreBcb.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    this.jurosAbusivosForm.mensagemBcbConsignado =
      `Análise calculada: taxa do contrato corresponde a ${pctContrato}% da média BCB e a prestação corresponde a ${pctParcela}% da prestação estimada pela média BCB.`;
  }

  async buscarTaxaBcbConsignado(): Promise<void> {
    const competenciaNormalizada = this.normalizarCompetenciaBcbConsignado();

    if (!competenciaNormalizada) {
      this.jurosAbusivosForm.mensagemBcbConsignado = 'Informe a competência no formato MM/AAAA. Ex.: 07/2023.';
      return;
    }

    this.jurosAbusivosForm.mensagemBcbConsignado = 'Buscando taxa BCB da competência...';

    try {
      const resp = await fetch('/api/taxas-bcb/modalidades/CONSIGNADO_TOTAL_PF/valores?limite=300');

      if (!resp.ok) {
        throw new Error(`HTTP ${resp.status}`);
      }

      const dados = await resp.json();

      const item = Array.isArray(dados)
        ? dados.find((x: any) => String(x.competencia).slice(0, 10) === competenciaNormalizada)
        : null;

      if (!item) {
        this.jurosAbusivosForm.mensagemBcbConsignado =
          `Não encontrei taxa BCB para a competência ${this.jurosAbusivosForm.competenciaBcbConsignado}. Rode a importação BCB e tente novamente.`;
        return;
      }

      const mensal = Number(item.taxa_mensal || 0);
      const anual = Number(item.taxa_anual || 0);

      this.jurosAbusivosForm.taxaMediaBcbConsignadoMensal = mensal;
      this.jurosAbusivosForm.taxaMediaBcbConsignadoAnual = anual;
      this.jurosAbusivosForm.fonteBcbConsignado =
        `BCB/SGS - ${item.codigo} - ${item.nome} - competência ${this.jurosAbusivosForm.competenciaBcbConsignado}`;

      const mensalTxt = mensal.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      const anualTxt = anual.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

      this.jurosAbusivosForm.mensagemBcbConsignado =
        `Taxa BCB carregada: ${mensalTxt}% a.m. e ${anualTxt}% a.a.`;
    } catch (e) {
      console.error(e);
      this.jurosAbusivosForm.mensagemBcbConsignado =
        'Erro ao buscar taxa BCB. Confira se o backend está no ar e se a importação foi realizada.';
    }
  }

  avaliacaoConsignadoBcb(): string {
    const perc = this.contratoSobreMediaBcbConsignado();

    if (!perc) {
      return 'Informe manualmente a taxa média BCB da competência para avaliar.';
    }

    if (perc <= 100) return 'Taxa contratual dentro ou abaixo da média BCB informada.';
    if (perc <= 150) return 'Taxa contratual acima da média BCB, em faixa de atenção.';
    if (perc <= 200) return 'Indício técnico de taxa elevada frente à média BCB.';

    return 'Indício técnico forte de taxa acima da média BCB.';
  }

  classeConsignadoBcb(): string {
    const perc = this.contratoSobreMediaBcbConsignado();

    if (!perc) return 'neutro';
    if (perc <= 150) return 'ok';
    if (perc <= 200) return 'alerta';

    return 'forte';
  }


  sinteseTecnicaHierarquia(): string {
    const r = this.jurosAbusivosResultado;
    const bcb = this.taxaBcbVeiculosReferencia;

    if (!r || !bcb) return '';

    const taxaContrato = Number(this.jurosAbusivosForm.taxaContratoMes || 0);
    const indicador = this.jurosAbusivosForm.indicador;

    const partes: string[] = [];

    partes.push(
      `A taxa contratual mensal informada foi de ${this.formatarNumero(taxaContrato, 2)}%, enquanto a taxa média BCB da modalidade aquisição de veículos PF foi de ${this.formatarNumero(bcb.taxaMensal, 2)}% ao mês.`
    );

    partes.push(
      `A taxa contratual corresponde a ${this.formatarNumero(bcb.contratoSobreMedia, 2)}% da média BCB da modalidade.`
    );

    partes.push(
      `Pela comparação de valores, o contrato alcançou ${this.formatarMoeda(r.valorPeloContrato)}, enquanto a projeção pela média BCB alcançou ${this.formatarMoeda(this.valorPelaMediaBcbVeiculos())}.`
    );

    partes.push(
      `A parcela contratada representa ${this.formatarNumero(this.percentualParcelaSobreMediaBcb(), 2)}% da parcela estimada pela média BCB.`
    );

    partes.push(
      `O indicador econômico selecionado (${indicador}) foi utilizado como apoio secundário, não como parâmetro principal de abusividade bancária.`
    );

    return partes.join(' ');
  }

  conclusaoTecnicaPericial(): string {
    const bcb = this.taxaBcbVeiculosReferencia;

    if (!bcb) {
      return 'Não há referência BCB carregada para emitir conclusão técnica comparativa.';
    }

    if (bcb.contratoSobreMedia >= 200) {
      return 'Conclusão técnico-contábil: há indício técnico forte de taxa contratual superior à média de mercado divulgada pelo Banco Central para a mesma modalidade e competência, recomendando análise detalhada do contrato, CET, IOF, seguros, tarifas, gravame e demais encargos.';
    }

    if (bcb.contratoSobreMedia >= 150) {
      return 'Conclusão técnico-contábil: há indício técnico de taxa contratual elevada em relação à média de mercado divulgada pelo Banco Central para a mesma modalidade e competência.';
    }

    if (bcb.contratoSobreMedia > 100) {
      return 'Conclusão técnico-contábil: a taxa contratual está acima da média BCB da modalidade, exigindo atenção técnica, mas sem ultrapassar a faixa de alerta forte definida no sistema.';
    }

    return 'Conclusão técnico-contábil: a taxa contratual está dentro ou abaixo da média BCB da modalidade, conforme os parâmetros informados.';
  }


  valorLiquidoFinanciadoVeiculo(): number {
    return Number(this.jurosAbusivosForm.valorBem || 0) - Number(this.jurosAbusivosForm.entrada || 0);
  }

  textoConclusaoJurosAbusivos(): string {
    const r = this.jurosAbusivosResultado;
    if (!r) return '';

    const indicador = this.jurosAbusivosForm.indicador;
    const taxa = Number(this.jurosAbusivosForm.taxaContratoMes || 0);
    const criterio = Number(this.jurosAbusivosForm.criterioAlerta || 150);

    return [
      `No período analisado, o valor original de ${this.formatarMoeda(r.valorOriginal)} foi projetado pela taxa contratual mensal de ${this.formatarNumero(taxa, 2)}% e comparado com o indicador de referência ${indicador}.`,
      `Pelo indicador selecionado, o valor atualizado alcançou ${this.formatarMoeda(r.valorPeloIndicador)}. Pela taxa contratual, o valor alcançou ${this.formatarMoeda(r.valorPeloContrato)}.`,
      `A diferença preliminar apurada foi de ${this.formatarMoeda(r.diferenca)}, com relação contrato/indicador de ${this.formatarNumero(r.percentualContratoSobreIndicador, 2)}%.`,
      `Considerando o critério de alerta de ${this.formatarNumero(criterio, 2)}%, a avaliação preliminar do sistema foi: ${r.avaliacao}.`,
      `Este resultado constitui apoio técnico preliminar e deve ser confrontado com contrato, modalidade da operação, CET, capitalização, encargos, pagamentos, extratos e parâmetros periciais aplicáveis.`
    ].join(' ');
  }

  copiarConclusaoJurosAbusivos(): void {
    const texto = this.textoConclusaoJurosAbusivos();
    if (!texto) return;

    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(texto).then(() => {
        alert('Conclusão copiada para a área de transferência.');
      });
    } else {
      alert(texto);
    }
  }

  exportarMemoriaJurosAbusivosCsv(): void {
    const r = this.jurosAbusivosResultado;
    if (!r) return;

    const linhas = [
      ['Competência', 'Taxa indicador %', 'Fator indicador', 'Valor pelo indicador', 'Valor pelo contrato', 'Diferença'],
      ...r.linhas.map(linha => [
        linha.competencia,
        this.formatarNumero(linha.taxaIndicador, 4),
        this.formatarNumero(linha.fatorIndicador, 8),
        this.formatarNumero(linha.valorPeloIndicador, 2),
        this.formatarNumero(linha.valorPeloContrato, 2),
        this.formatarNumero(linha.diferenca, 2)
      ])
    ];

    const csv = linhas
      .map(linha => linha.map(campo => `"${String(campo).replace(/"/g, '""')}"`).join(';'))
      .join(String.fromCharCode(10));

    const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');

    a.href = url;
    a.download = `memoria_juros_abusivos_${this.jurosAbusivosForm.indicador}.csv`;
    a.click();

    URL.revokeObjectURL(url);
  }

  selecionarArquivoCartao(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.arquivoCartaoSelecionado = input.files?.[0] || null;
    this.resultadoCartao = null;
    this.erroCartao = '';
    this.mensagemCartao = this.arquivoCartaoSelecionado ? `Arquivo selecionado: ${this.arquivoCartaoSelecionado.name}` : '';
  }

  analisarCartaoCredito(): void {
    if (!this.arquivoCartaoSelecionado) {
      this.erroCartao = 'Selecione uma planilha Excel antes de analisar.';
      return;
    }

    this.carregandoCartao = true;
    this.erroCartao = '';
    this.mensagemCartao = 'Lendo a planilha...';
    this.resultadoCartao = null;

    this.analiticosService.analisarCartaoCredito(this.arquivoCartaoSelecionado).subscribe({
      next: (resultado) => {
        this.resultadoCartao = resultado;
        this.carregandoCartao = false;

        if (!resultado.aba_encontrada) {
          this.erroCartao = 'A aba CARTÃO DE CRÉDITO - AJUSTADA não foi encontrada na planilha.';
          this.mensagemCartao = '';
          return;
        }

        this.mensagemCartao = `${resultado.total_registros} registro(s) carregado(s) da aba ${resultado.aba_lida}.`;
      },
      error: () => {
        this.carregandoCartao = false;
        this.erroCartao = 'Não foi possível ler a planilha. Verifique se o backend está rodando e se o arquivo é Excel válido.';
        this.mensagemCartao = '';
      }
    });
  }

  limparCartaoCredito(): void {
    this.arquivoCartaoSelecionado = null;
    this.resultadoCartao = null;
    this.carregandoCartao = false;
    this.baixandoRelatorioCartao = false;
    this.erroCartao = '';
    this.mensagemCartao = '';
  }

  baixarPlanilhaRetornoCartao(): void {
    if (!this.arquivoCartaoSelecionado) {
      this.erroCartao = 'Selecione uma planilha antes de baixar o retorno.';
      return;
    }

    this.baixandoRelatorioCartao = true;
    this.erroCartao = '';

    this.analiticosService.baixarRelatorioCartaoCredito(this.arquivoCartaoSelecionado).subscribe({
      next: (blob) => {
        this.baixandoRelatorioCartao = false;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'cartao_credito_retorno_pericial.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.baixandoRelatorioCartao = false;
        this.erroCartao = 'Não foi possível gerar a planilha de retorno.';
      }
    });
  }

  linhasCartaoVisiveis(): any[] {
    return this.resultadoCartao?.linhas.slice(0, this.limiteLinhasCartao) || [];
  }

  valorCelulaCartao(linha: any, coluna: string): any {
    const valor = linha[coluna];
    return valor === null || valor === undefined ? '' : valor;
  }

  valorCelulaCartaoZero(linha: any, coluna: string): any {
    const valor = linha[coluna];
    return valor === null || valor === undefined || valor === '' ? 0 : valor;
  }

  colunasEntradaCartao(): string[] {
    return this.resultadoCartao?.colunas.filter(c => !this.colunasConferenciaCartao().includes(c) && !this.colunasAjusteCartao().includes(c) && c !== 'Descrição Técnica' && c !== 'Status Análise') || [];
  }

  colunasConferenciaCartao(): string[] {
    return [
      'Vlr. Fatura',
      'Pgto. Mínimo',
      'Dias de Mora',
      'Saldo Fin.',
      'Status Análise'
    ];
  }

  colunasAjusteCartao(): string[] {
    return [
      'IOF',
      'Juros Rem. Devidos',
      'Multa',
      'Juros Mora',
      'TAXA SELIC',
      'Abusividade?',
      'Enc. Cobrados',
      'Enc. Devidos',
      'Dif. A compensar',
      'Juros Acum.',
      'Dias',
      'Juros Atual.',
      'Juros Quitados',
      'Juros Devidos'
    ];
  }

  colunasExistentesCartao(colunas: string[]): string[] {
    return colunas.filter(c => this.resultadoCartao?.colunas.includes(c));
  }



  gerarAcertoRescisorioDemo(): void {
    this.acertoDetalheMensal = [
      {
        id_funcionario: 101,
        nome: 'Funcionário Exemplo 01',
        competencia: '2026-01',
        tipo_evento: 'HORA_EXTRA_50',
        salario_base: 3200,
        hora_extra_50: 327.27,
        hora_extra_100: 0,
        dsr_sobre_he: 65.45,
        fgts_mensal: 287.42,
        vr_total_liquido_rescisao: 0
      },
      {
        id_funcionario: 101,
        nome: 'Funcionário Exemplo 01',
        competencia: '2026-02',
        tipo_evento: 'COMISSAO',
        salario_base: 3200,
        hora_extra_50: 0,
        hora_extra_100: 232.73,
        dsr_sobre_he: 46.55,
        fgts_mensal: 302.34,
        vr_total_liquido_rescisao: 0
      },
      {
        id_funcionario: 101,
        nome: 'Funcionário Exemplo 01',
        competencia: '2026-03',
        tipo_evento: 'RESCISAO',
        salario_base: 3200,
        hora_extra_50: 163.64,
        hora_extra_100: 0,
        dsr_sobre_he: 32.73,
        fgts_mensal: 271.71,
        vr_total_liquido_rescisao: 8234.61
      }
    ];

    this.acertoMemoriaLong = [
      { id_funcionario: 101, nome: 'Funcionário Exemplo 01', competencia: '2026-03', verba: 'RESCISAO_SALDO_SALARIO', valor: 2133.33, fator_correcao: 1, valor_corrigido: 2133.33 },
      { id_funcionario: 101, nome: 'Funcionário Exemplo 01', competencia: '2026-03', verba: 'RESCISAO_AVISO_PREVIO', valor: 3200.00, fator_correcao: 1, valor_corrigido: 3200.00 },
      { id_funcionario: 101, nome: 'Funcionário Exemplo 01', competencia: '2026-03', verba: 'RESCISAO_13O_TOTAL', valor: 906.67, fator_correcao: 1, valor_corrigido: 906.67 },
      { id_funcionario: 101, nome: 'Funcionário Exemplo 01', competencia: '2026-03', verba: 'RESCISAO_FERIAS_PROP_TOTAL', valor: 925.33, fator_correcao: 1, valor_corrigido: 925.33 },
      { id_funcionario: 101, nome: 'Funcionário Exemplo 01', competencia: '2026-03', verba: 'RESCISAO_TERCO_FERIAS_TOTAL', valor: 308.44, fator_correcao: 1, valor_corrigido: 308.44 },
      { id_funcionario: 101, nome: 'Funcionário Exemplo 01', competencia: '2026-03', verba: 'RESCISAO_MULTA_FGTS', valor: 344.59, fator_correcao: 1, valor_corrigido: 344.59 },
      { id_funcionario: 101, nome: 'Funcionário Exemplo 01', competencia: '2026-03', verba: 'RESCISAO_INSS', valor: 529.64, fator_correcao: 1, valor_corrigido: 529.64 },
      { id_funcionario: 101, nome: 'Funcionário Exemplo 01', competencia: '2026-03', verba: 'RESCISAO_IRRF', valor: 154.11, fator_correcao: 1, valor_corrigido: 154.11 }
    ];

    this.acertoResumoFinal = [
      {
        id_funcionario: 101,
        nome: 'Funcionário Exemplo 01',
        dias_aviso: 30,
        competencia_projetada_aviso: '2026-04',
        avos_13o_sem_projecao: 3,
        avos_13o_com_projecao: 4,
        avos_ferias_sem_projecao: 3,
        avos_ferias_com_projecao: 4,
        dias_mes: 31,
        domingos_mes: 13,
        feriados_mes: 1,
        dias_descanso: 14,
        dias_uteis_mes: 49,
        hora_extra_50: 490.91,
        hora_extra_100: 232.73,
        dsr_sobre_he: 144.73,
        adicional_noturno: 0,
        comissao: 500,
        evento_percentual: 0,
        fgts_mensal: 861.47,
        vr_fgts_aviso_previo: 256,
        total_fgts: 1117.47,
        vr_saldo_salario: 2133.33,
        vr_aviso_previo: 3200,
        vr_13o_base: 1066.67,
        vr_reflexo_he_dsr_13o: 57.71,
        vr_13o_total: 1124.38,
        vr_ferias_vencidas: 0,
        vr_ferias_proporcionais_base: 1066.67,
        vr_reflexo_he_dsr_ferias: 57.71,
        vr_ferias_proporcionais_total: 1124.38,
        vr_terco_ferias_base: 355.56,
        vr_reflexo_he_dsr_terco: 19.24,
        vr_terco_ferias_total: 374.80,
        vr_multa_fgts: 446.99,
        vr_total_bruto_rescisao: 8403.88,
        vr_inss: 529.64,
        vr_irrf: 154.11,
        vr_pensao: 0,
        vr_total_descontos_rescisao: 683.75,
        vr_total_liquido_rescisao: 7720.13
      }
    ];

    this.acertoAchados = [
      'ACH-ACERTO-001 — Saída output_table_1 estruturada como detalhe mensal com eventos, DSR, FGTS e verbas por competência.',
      'ACH-ACERTO-002 — Saída output_table_2 estruturada em formato longo para memória de cálculo, com verba, valor, fator de correção e valor corrigido.',
      'ACH-ACERTO-003 — Saída output_table_3 consolidada por id_funcionario e nome, usando máximos para avos/dias e somas para eventos, verbas, descontos e líquido.',
      'ACH-ACERTO-004 — O padrão permite integrar o resultado do KNIME ou Python ao PeritoDesk antes de gravar no banco.'
    ];
  }

  limparAcertoRescisorioDemo(): void {
    this.acertoResumoFinal = [];
    this.acertoMemoriaLong = [];
    this.acertoDetalheMensal = [];
    this.acertoAchados = [];
  }

  exportarAcertoRescisorioDemo(): void {
    if (!this.acertoResumoFinal.length) {
      this.gerarAcertoRescisorioDemo();
    }

    const linhas = [
      ['PeritoDesk — Acerto rescisório demonstrativo'],
      ['Tabela', 'Campo', 'Valor'],
      ['Resumo final', 'Total bruto', this.formatarMoeda(this.acertoResumoFinal[0]?.vr_total_bruto_rescisao || 0)],
      ['Resumo final', 'Total descontos', this.formatarMoeda(this.acertoResumoFinal[0]?.vr_total_descontos_rescisao || 0)],
      ['Resumo final', 'Total líquido', this.formatarMoeda(this.acertoResumoFinal[0]?.vr_total_liquido_rescisao || 0)],
      [],
      ['Memória', 'Funcionário', 'Competência', 'Verba', 'Valor', 'Fator', 'Valor corrigido']
    ];

    this.acertoMemoriaLong.forEach((m) => {
      linhas.push(['Memória', m.nome, m.competencia, m.verba, this.formatarNumero(m.valor, 2), this.formatarNumero(m.fator_correcao, 4), this.formatarNumero(m.valor_corrigido, 2)]);
    });

    const csv = linhas.map((linha) => linha.map((valor) => `"${String(valor ?? '').replace(/"/g, '""')}"`).join(';')).join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'acerto_rescisorio_demo.csv';
    a.click();
    window.URL.revokeObjectURL(url);
  }

  calcularVerbasTrabalhistas(): void {
    const salario = Number(this.verbasForm.salarioBase || 0);
    const diasSaldo = Number(this.verbasForm.diasSaldoSalario || 0);
    const avisoDias = Number(this.verbasForm.avisoPrevioDias || 0);
    const feriasAvos = Number(this.verbasForm.feriasProporcionaisAvos || 0);
    const decimoAvos = Number(this.verbasForm.decimoTerceiroAvos || 0);

    const saldoSalario = (salario / 30) * diasSaldo;
    const avisoPrevio = this.verbasForm.tipoRescisao === 'SEM_JUSTA_CAUSA' ? (salario / 30) * avisoDias : 0;
    const decimoTerceiro = (salario / 12) * decimoAvos;
    const feriasVencidasValor = this.verbasForm.feriasVencidas ? salario : 0;
    const feriasProporcionais = (salario / 12) * feriasAvos;
    const tercoFerias = (feriasVencidasValor + feriasProporcionais) / 3;
    const baseFgtsEstimada = saldoSalario + avisoPrevio + decimoTerceiro;
    const fgtsEstimado = Number(this.verbasForm.fgtsSaldoInformado || 0) || (baseFgtsEstimada * 0.08);
    const multaFgts = this.verbasForm.considerarMultaFgts && this.verbasForm.tipoRescisao === 'SEM_JUSTA_CAUSA' ? fgtsEstimado * 0.40 : 0;
    const totalBruto = saldoSalario + avisoPrevio + decimoTerceiro + feriasVencidasValor + feriasProporcionais + tercoFerias;
    const totalComFgts = totalBruto + fgtsEstimado + multaFgts;

    const achados: string[] = [
      `ACH-TRAB-001 — Saldo de salário calculado sobre ${diasSaldo} dia(s): ${this.formatarMoeda(saldoSalario)}.`,
      `ACH-TRAB-002 — 13º proporcional calculado em ${decimoAvos}/12: ${this.formatarMoeda(decimoTerceiro)}.`,
      `ACH-TRAB-003 — Férias proporcionais em ${feriasAvos}/12 com 1/3 constitucional: ${this.formatarMoeda(feriasProporcionais + tercoFerias)}.`
    ];

    if (multaFgts > 0) {
      achados.push(`ACH-TRAB-004 — Multa de 40% sobre FGTS estimado/informado: ${this.formatarMoeda(multaFgts)}.`);
    }

    this.verbasResultado = {
      saldoSalario,
      avisoPrevio,
      decimoTerceiro,
      feriasVencidasValor,
      feriasProporcionais,
      tercoFerias,
      baseFgtsEstimada,
      fgtsEstimado,
      multaFgts,
      totalBruto,
      totalComFgts,
      achados,
      resumo: `Foi realizada apuração demonstrativa de verbas trabalhistas com salário base de ${this.formatarMoeda(salario)}. O total bruto estimado é de ${this.formatarMoeda(totalBruto)} e, considerando FGTS/multa quando aplicável, o total demonstrativo é de ${this.formatarMoeda(totalComFgts)}.`
    };
  }

  limparVerbasTrabalhistas(): void {
    this.verbasResultado = null;
    this.verbasForm = {
      salarioBase: null,
      dataAdmissao: '',
      dataDemissao: '',
      tipoRescisao: 'SEM_JUSTA_CAUSA',
      diasSaldoSalario: null,
      avisoPrevioDias: null,
      feriasVencidas: false,
      feriasProporcionaisAvos: null,
      decimoTerceiroAvos: null,
      fgtsSaldoInformado: null,
      considerarMultaFgts: true
    };
  }

  calcularHorasExtras(): void {
    const salario = Number(this.horasForm.salarioBase || 0);
    const jornada = Number(this.horasForm.jornadaMensal || 220);
    const horas50 = Number(this.horasForm.horas50 || 0);
    const horas100 = Number(this.horasForm.horas100 || 0);
    const adicionalNoturnoHoras = Number(this.horasForm.adicionalNoturnoHoras || 0);
    const dsrPercentual = Number(this.horasForm.dsrPercentual || 0) / 100;
    const reflexosPercentual = Number(this.horasForm.reflexosPercentual || 0) / 100;

    const valorHora = jornada ? salario / jornada : 0;
    const horas50Valor = valorHora * 1.5 * horas50;
    const horas100Valor = valorHora * 2 * horas100;
    const adicionalNoturnoValor = valorHora * 0.2 * adicionalNoturnoHoras;
    const totalHoras = horas50Valor + horas100Valor + adicionalNoturnoValor;
    const dsr = totalHoras * dsrPercentual;
    const reflexos = (totalHoras + dsr) * reflexosPercentual;
    const totalGeral = totalHoras + dsr + reflexos;

    const achados = [
      `ACH-HORAS-001 — Valor da hora calculado: ${this.formatarMoeda(valorHora)} com jornada mensal de ${jornada}h.`,
      `ACH-HORAS-002 — Horas extras 50%: ${horas50}h, total ${this.formatarMoeda(horas50Valor)}.`,
      `ACH-HORAS-003 — Horas extras 100%: ${horas100}h, total ${this.formatarMoeda(horas100Valor)}.`,
      `ACH-HORAS-004 — DSR/reflexos demonstrativos totalizam ${this.formatarMoeda(dsr + reflexos)}.`
    ];

    this.horasResultado = {
      valorHora,
      horas50Valor,
      horas100Valor,
      adicionalNoturnoValor,
      totalHoras,
      dsr,
      reflexos,
      totalGeral,
      achados,
      resumo: `Foi realizada apuração demonstrativa de horas extras com salário base de ${this.formatarMoeda(salario)} e jornada mensal de ${jornada}h. O total de horas/adicionais é de ${this.formatarMoeda(totalHoras)}, com DSR/reflexos estimados de ${this.formatarMoeda(dsr + reflexos)}, totalizando ${this.formatarMoeda(totalGeral)}.`
    };
  }

  limparHorasExtras(): void {
    this.horasResultado = null;
    this.horasForm = {
      salarioBase: null,
      jornadaMensal: 220,
      horas50: null,
      horas100: null,
      adicionalNoturnoHoras: null,
      dsrPercentual: 16.67,
      reflexosPercentual: 18.33
    };
  }

  calcularJurosBancarios(): void {
    this.atualizarValorTotalFinanciado();

    const baseCalculo = Number(this.jurosForm.valorTotalFinanciado || this.jurosForm.valorFinanciamento || 0);
    const parcelaContrato = Number(this.jurosForm.valorParcela || 0);
    const numeroParcelas = Number(this.jurosForm.numeroParcelas || 0);
    const taxaMensal = Number(this.jurosForm.taxaMensal || 0) / 100;
    const cetMensal = Number(this.jurosForm.cetMensal || 0) / 100;
    const multaMora = Number(this.jurosForm.multaMora || 0) / 100;
    const jurosMoraMensal = Number(this.jurosForm.jurosMoraMensal || 0) / 100;

    const parcelaRecalculada = this.calcularParcelaPrice(baseCalculo, taxaMensal, numeroParcelas);
    const parcelas = this.gerarTabelaAmortizacao(
      baseCalculo,
      parcelaContrato,
      parcelaRecalculada,
      numeroParcelas,
      taxaMensal,
      this.jurosForm.sistema
    );

    const totalContrato = parcelaContrato * numeroParcelas;
    const totalRecalculado = parcelaRecalculada * numeroParcelas;
    const diferencaMensal = parcelaContrato - parcelaRecalculada;
    const diferencaTotalNominal = diferencaMensal * numeroParcelas;
    const totalJurosContrato = totalContrato - baseCalculo;
    const totalJurosRecalculado = totalRecalculado - baseCalculo;
    const totalJurosTabela = parcelas.reduce((soma, p) => soma + p.juros, 0);
    const totalAmortizado = parcelas.reduce((soma, p) => soma + p.amortizacao, 0);
    const saldoFinal = parcelas.length ? parcelas[parcelas.length - 1].saldoFinal : baseCalculo;
    const totalJs = parcelas.reduce((soma, p) => soma + p.jurosPercentual, 0);
    const totalJurosLinear = parcelas.reduce((soma, p) => soma + p.juros, 0);
    const taxaAnualEfetiva = (Math.pow(1 + taxaMensal, 12) - 1) * 100;
    const cetAnualEfetiva = cetMensal > 0 ? (Math.pow(1 + cetMensal, 12) - 1) * 100 : 0;

    const diasAtraso = this.calcularDiasAtraso(this.jurosForm.dataVencimento, this.jurosForm.dataPagamento);
    const multaValor = diasAtraso > 0 ? parcelaContrato * multaMora : 0;
    const jurosMoraValor = diasAtraso > 0 ? parcelaContrato * jurosMoraMensal * (diasAtraso / 30) : 0;
    const valorParcelaAtualizada = parcelaContrato + multaValor + jurosMoraValor;

    const achados = this.gerarAchadosBancarios(
      parcelaContrato,
      parcelaRecalculada,
      diferencaMensal,
      taxaAnualEfetiva,
      cetAnualEfetiva,
      baseCalculo
    );

    this.jurosResultado = {
      baseCalculo,
      taxaMensalEfetiva: taxaMensal * 100,
      taxaAnualEfetiva,
      cetMensal: cetMensal * 100,
      cetAnualEfetiva,
      parcelaContrato,
      parcelaRecalculada,
      diferencaMensal,
      diferencaTotalNominal,
      totalContrato,
      totalRecalculado,
      totalJurosContrato,
      totalJurosRecalculado,
      totalJurosTabela,
      totalAmortizado,
      saldoFinal,
      diasAtraso,
      multaValor,
      jurosMoraValor,
      valorParcelaAtualizada,
      totalJurosLinear,
      totalJs,
      parcelas,
      achados,
      resumo:
        `Foi realizada simulação demonstrativa do financiamento bancário com base de cálculo de ${this.formatarMoeda(baseCalculo)}, ` +
        `prazo de ${numeroParcelas} parcela(s), taxa mensal de ${(taxaMensal * 100).toFixed(4)}% e sistema ${this.rotuloSistemaJuros()}. ` +
        `A parcela contratual informada foi de ${this.formatarMoeda(parcelaContrato)}, enquanto a parcela recalculada foi de ${this.formatarMoeda(parcelaRecalculada)}. ` +
        `A diferença mensal estimada é de ${this.formatarMoeda(diferencaMensal)}, com diferença nominal total de ${this.formatarMoeda(diferencaTotalNominal)}. ` +
        `A taxa anual efetiva calculada é de ${taxaAnualEfetiva.toFixed(4)}% e o CET anual equivalente é de ${cetAnualEfetiva.toFixed(4)}%.`
    };
  }

  atualizarValorTotalFinanciado(): void {
    const valorFinanciamento = Number(this.jurosForm.valorFinanciamento || 0);
    const iof = Number(this.jurosForm.valorIof || 0);
    const cartorio = Number(this.jurosForm.despesaCartorio || 0);
    const gravame = Number(this.jurosForm.despesaGravame || 0);
    const comissao = Number(this.jurosForm.comissaoOrigem || 0);

    this.jurosForm.valorTotalFinanciado = valorFinanciamento + iof + cartorio + gravame + comissao;
  }

  preencherExemploFinanciamento(): void {
    this.jurosForm = {
      valorVeiculo: 30696,
      entrada: 5496,
      valorFinanciamento: 25200,
      valorIof: 476.32,
      despesaCartorio: null,
      despesaGravame: null,
      comissaoOrigem: null,
      valorTotalFinanciado: 25676.32,
      valorParcela: 685.15,
      numeroParcelas: 60,
      taxaMensal: 1.53,
      taxaAnual: 19.94,
      cetMensal: 1.77,
      cetAnual: 23.39,
      dataAssinatura: '2009-03-23',
      dataPrimeiraParcela: '2009-04-23',
      dataUltimaParcela: '2014-03-23',
      multaMora: 2.0,
      jurosMoraMensal: 1.0,
      dataVencimento: '',
      dataPagamento: '',
      sistema: 'FIXA_LINEAR'
    };

    this.calcularJurosBancarios();
  }

  calcularParcelaPrice(valor: number, taxaMensal: number, numeroParcelas: number): number {
    if (!valor || !numeroParcelas) return 0;
    if (!taxaMensal) return valor / numeroParcelas;

    return valor * (taxaMensal / (1 - Math.pow(1 + taxaMensal, -numeroParcelas)));
  }

  gerarTabelaAmortizacao(
    valorLiberado: number,
    valorParcelaContrato: number,
    valorParcelaRecalculada: number,
    numeroParcelas: number,
    taxaMensal: number,
    sistema: string
  ): ParcelaAmortizacao[] {
    const parcelas: ParcelaAmortizacao[] = [];

    if (!valorLiberado || !numeroParcelas || numeroParcelas <= 0) {
      return parcelas;
    }

    let saldo = valorLiberado;
    const sistemaNormalizado = (sistema || 'FIXA_LINEAR').toUpperCase();
    const amortizacaoFixa = valorLiberado / numeroParcelas;

    for (let i = 1; i <= numeroParcelas; i++) {
      const saldoInicial = saldo;
      const fatorJs = Math.pow(1 + taxaMensal, i);
      const jurosPercentual = fatorJs - 1;
      const juros = saldoInicial * taxaMensal;
      const jsInverso = fatorJs ? 1 / fatorJs : 0;

      let parcelaRecalculada = valorParcelaRecalculada;
      let amortizacao = parcelaRecalculada - juros;

      if (sistemaNormalizado === 'SAC' || sistemaNormalizado === 'FIXA_LINEAR') {
        amortizacao = Math.min(amortizacaoFixa, saldoInicial);
        parcelaRecalculada = amortizacao + juros;
      }

      if (sistemaNormalizado === 'PRICE') {
        amortizacao = Math.max(0, parcelaRecalculada - juros);
      }

      const saldoFinal = Math.max(0, saldoInicial - amortizacao);
      const diferencaParcela = valorParcelaContrato - parcelaRecalculada;

      parcelas.push({
        numero: i,
        saldoInicial,
        fatorJs,
        jurosPercentual,
        juros,
        parcelaContrato: valorParcelaContrato,
        parcelaRecalculada,
        amortizacao,
        saldoFinal,
        jsInverso,
        diferencaParcela
      });

      saldo = saldoFinal;
      if (saldo <= 0.005) {
        saldo = 0;
      }
    }

    return parcelas;
  }

  gerarAchadosBancarios(
    parcelaContrato: number,
    parcelaRecalculada: number,
    diferencaMensal: number,
    taxaAnualEfetiva: number,
    cetAnualEfetiva: number,
    baseCalculo: number
  ): string[] {
    const achados: string[] = [];

    if (Math.abs(diferencaMensal) >= 0.01) {
      achados.push(`ACH-001 — Divergência entre parcela contratual (${this.formatarMoeda(parcelaContrato)}) e parcela recalculada (${this.formatarMoeda(parcelaRecalculada)}).`);
    }

    if (cetAnualEfetiva > taxaAnualEfetiva) {
      achados.push(`ACH-002 — CET anual equivalente (${this.formatarPercentual(cetAnualEfetiva)}) superior à taxa anual efetiva da taxa nominal (${this.formatarPercentual(taxaAnualEfetiva)}).`);
    }

    if (Number(this.jurosForm.valorIof || 0) > 0 || Number(this.jurosForm.despesaCartorio || 0) > 0 || Number(this.jurosForm.despesaGravame || 0) > 0 || Number(this.jurosForm.comissaoOrigem || 0) > 0) {
      achados.push(`ACH-003 — Valor total financiado inclui encargos/despesas agregadas à base de cálculo. Base simulada: ${this.formatarMoeda(baseCalculo)}.`);
    }

    if (!achados.length) {
      achados.push('ACH-000 — Não foram identificadas divergências automáticas relevantes nesta simulação demonstrativa.');
    }

    return achados;
  }

  limparJurosBancarios(): void {
    this.jurosResultado = null;
    this.jurosForm = {
      valorVeiculo: null,
      entrada: null,
      valorFinanciamento: null,
      valorIof: null,
      despesaCartorio: null,
      despesaGravame: null,
      comissaoOrigem: null,
      valorTotalFinanciado: null,
      valorParcela: null,
      numeroParcelas: null,
      taxaMensal: null,
      taxaAnual: null,
      cetMensal: null,
      cetAnual: null,
      dataAssinatura: '',
      dataPrimeiraParcela: '',
      dataUltimaParcela: '',
      multaMora: 2.0,
      jurosMoraMensal: 1.0,
      dataVencimento: '',
      dataPagamento: '',
      sistema: 'FIXA_LINEAR'
    };
  }

  rotuloSistemaJuros(): string {
    const mapa: Record<string, string> = {
      FIXA_LINEAR: 'Fixa linear',
      PRICE: 'Tabela Price',
      SAC: 'SAC',
      BULLET: 'Bullet',
      OUTRO: 'Outro'
    };

    return mapa[this.jurosForm.sistema] || this.jurosForm.sistema || 'Não informado';
  }

  exportarMemoriaBancariaDemo(): void {
    if (!this.jurosResultado) {
      this.calcularJurosBancarios();
    }

    const resultado = this.jurosResultado;
    if (!resultado) return;

    const linhas = [
      ['PeritoDesk — Memória demonstrativa de financiamento bancário'],
      ['Campo', 'Valor'],
      ['Valor do veículo', this.formatarMoeda(Number(this.jurosForm.valorVeiculo || 0))],
      ['Entrada', this.formatarMoeda(Number(this.jurosForm.entrada || 0))],
      ['Valor total financiado', this.formatarMoeda(resultado.baseCalculo)],
      ['Parcela contratual', this.formatarMoeda(resultado.parcelaContrato)],
      ['Parcela recalculada', this.formatarMoeda(resultado.parcelaRecalculada)],
      ['Diferença mensal', this.formatarMoeda(resultado.diferencaMensal)],
      ['Diferença total nominal', this.formatarMoeda(resultado.diferencaTotalNominal)],
      [],
      ['Parcela', 'Saldo inicial', 'Fator JS', 'Juros %', 'Juros R$', 'Parcela contrato', 'Parcela recalculada', 'Amortização', 'Saldo final', 'JS^-1', 'Diferença']
    ];

    resultado.parcelas.forEach((p) => {
      linhas.push([
        String(p.numero),
        this.formatarNumero(p.saldoInicial, 2),
        this.formatarNumero(p.fatorJs, 5),
        this.formatarNumero(p.jurosPercentual, 5),
        this.formatarNumero(p.juros, 2),
        this.formatarNumero(p.parcelaContrato, 2),
        this.formatarNumero(p.parcelaRecalculada, 2),
        this.formatarNumero(p.amortizacao, 2),
        this.formatarNumero(p.saldoFinal, 2),
        this.formatarNumero(p.jsInverso, 5),
        this.formatarNumero(p.diferencaParcela, 2)
      ]);
    });

    const csv = linhas.map((linha) => linha.map((valor) => `"${String(valor ?? '').replace(/"/g, '""')}"`).join(';')).join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'memoria_financiamento_bancario_demo.csv';
    a.click();
    window.URL.revokeObjectURL(url);
  }

  formatarNumero(valor: number, casas = 2): string {
    return (valor || 0).toFixed(casas).replace('.', ',');
  }


  calcularConsignado(): void {
    const valorCapital = Number(this.consignadoForm.valorCapital || 0);
    const parcelaContrato = Number(this.consignadoForm.valorParcela || 0);
    const numeroParcelas = Number(this.consignadoForm.numeroParcelas || 0);
    const taxaMensal = Number(this.consignadoForm.taxaMensal || 0) / 100;
    const cetMensal = Number(this.consignadoForm.cetMensal || 0) / 100;
    const diasCarencia = Number(this.consignadoForm.diasCarencia || 0);

    const jurosCarenciaPercentual = this.consignadoForm.jurosCarenciaPercentual !== null && this.consignadoForm.jurosCarenciaPercentual !== undefined
      ? Number(this.consignadoForm.jurosCarenciaPercentual || 0) / 100
      : taxaMensal * (diasCarencia / 30);

    const jurosCarencia = valorCapital * jurosCarenciaPercentual;
    const saldoPosCarencia = valorCapital + jurosCarencia;
    const parcelaRecalculada = this.calcularParcelaPrice(saldoPosCarencia, taxaMensal, numeroParcelas);
    const parcelas = this.gerarTabelaConsignado(saldoPosCarencia, parcelaContrato, parcelaRecalculada, numeroParcelas, taxaMensal);

    const totalContrato = parcelaContrato * numeroParcelas;
    const totalRecalculado = parcelaRecalculada * numeroParcelas;
    const diferencaMensal = parcelaContrato - parcelaRecalculada;
    const diferencaTotal = diferencaMensal * numeroParcelas;
    const taxaAnualEfetiva = (Math.pow(1 + taxaMensal, 12) - 1) * 100;
    const cetAnualEfetiva = cetMensal > 0 ? (Math.pow(1 + cetMensal, 12) - 1) * 100 : 0;
    const totalJurosContrato = totalContrato - saldoPosCarencia;
    const totalJurosRecalculado = totalRecalculado - saldoPosCarencia;

    const achados = this.gerarAchadosConsignado(
      parcelaContrato,
      parcelaRecalculada,
      diferencaMensal,
      jurosCarencia,
      taxaAnualEfetiva,
      cetAnualEfetiva
    );

    this.consignadoResultado = {
      valorCapital,
      jurosCarencia,
      saldoPosCarencia,
      parcelaContrato,
      parcelaRecalculada,
      diferencaMensal,
      diferencaTotal,
      taxaMensal: taxaMensal * 100,
      taxaAnualEfetiva,
      cetMensal: cetMensal * 100,
      cetAnualEfetiva,
      totalContrato,
      totalRecalculado,
      totalJurosContrato,
      totalJurosRecalculado,
      parcelas,
      achados,
      resumo:
        `Foi realizada simulação demonstrativa de crédito consignado com capital de ${this.formatarMoeda(valorCapital)}, ` +
        `carência de ${diasCarencia} dia(s), juros de carência de ${this.formatarMoeda(jurosCarencia)} e saldo base após carência de ${this.formatarMoeda(saldoPosCarencia)}. ` +
        `A parcela contratual informada foi de ${this.formatarMoeda(parcelaContrato)}, enquanto a parcela recalculada foi de ${this.formatarMoeda(parcelaRecalculada)}. ` +
        `A diferença mensal estimada é de ${this.formatarMoeda(diferencaMensal)}, com diferença nominal total de ${this.formatarMoeda(diferencaTotal)}.`
    };
  }

  gerarTabelaConsignado(
    saldoInicialBase: number,
    parcelaContrato: number,
    parcelaRecalculada: number,
    numeroParcelas: number,
    taxaMensal: number
  ): ParcelaConsignado[] {
    const parcelas: ParcelaConsignado[] = [];
    let saldo = saldoInicialBase;

    for (let i = 1; i <= numeroParcelas; i++) {
      const saldoInicial = saldo;
      const juros = saldoInicial * taxaMensal;
      const amortizacao = Math.max(0, parcelaRecalculada - juros);
      const saldoFinal = Math.max(0, saldoInicial - amortizacao);
      const fator = Math.pow(1 + taxaMensal, i);
      const diferencaParcela = parcelaContrato - parcelaRecalculada;

      parcelas.push({
        numero: i,
        saldoInicial,
        juros,
        amortizacao,
        parcela: parcelaRecalculada,
        saldoFinal,
        fator,
        diferencaParcela
      });

      saldo = saldoFinal;
      if (saldo <= 0.005) saldo = 0;
    }

    return parcelas;
  }

  gerarAchadosConsignado(
    parcelaContrato: number,
    parcelaRecalculada: number,
    diferencaMensal: number,
    jurosCarencia: number,
    taxaAnualEfetiva: number,
    cetAnualEfetiva: number
  ): string[] {
    const achados: string[] = [];

    if (jurosCarencia > 0) {
      achados.push(`ACH-CONS-001 — Identificados juros de carência no valor estimado de ${this.formatarMoeda(jurosCarencia)} antes da primeira parcela.`);
    }

    if (Math.abs(diferencaMensal) >= 0.01) {
      achados.push(`ACH-CONS-002 — Divergência entre parcela contratual (${this.formatarMoeda(parcelaContrato)}) e parcela recalculada (${this.formatarMoeda(parcelaRecalculada)}).`);
    }

    if (cetAnualEfetiva > taxaAnualEfetiva) {
      achados.push(`ACH-CONS-003 — CET anual equivalente (${this.formatarPercentual(cetAnualEfetiva)}) superior à taxa anual efetiva da taxa nominal (${this.formatarPercentual(taxaAnualEfetiva)}).`);
    }

    if (!achados.length) {
      achados.push('ACH-CONS-000 — Não foram identificadas divergências automáticas relevantes nesta simulação demonstrativa.');
    }

    return achados;
  }

  limparConsignado(): void {
    this.consignadoResultado = null;
    this.consignadoForm = {
      valorCapital: null,
      valorParcela: null,
      numeroParcelas: null,
      taxaMensal: null,
      taxaAnual: null,
      cetMensal: null,
      cetAnual: null,
      dataAssinatura: '',
      dataBase: '',
      dataPrimeiraParcela: '',
      dataUltimaParcela: '',
      diasCarencia: null,
      jurosCarenciaPercentual: null,
      sistema: 'CONSIGNADO_PRICE'
    };
  }

  preencherExemploConsignado(): void {
    this.consignadoForm = {
      valorCapital: 22045.55,
      valorParcela: 518.50,
      numeroParcelas: 63,
      taxaMensal: 1.33,
      taxaAnual: 16.76,
      cetMensal: 1.30,
      cetAnual: 16.74,
      dataAssinatura: '2019-06-14',
      dataBase: '2019-07-14',
      dataPrimeiraParcela: '2019-08-01',
      dataUltimaParcela: '2024-10-01',
      diasCarencia: 18,
      jurosCarenciaPercentual: 0.75,
      sistema: 'CONSIGNADO_PRICE'
    };

    this.calcularConsignado();
  }

  exportarMemoriaConsignadoDemo(): void {
    if (!this.consignadoResultado) {
      this.calcularConsignado();
    }

    const resultado = this.consignadoResultado;
    if (!resultado) return;

    const linhas = [
      ['PeritoDesk — Memória demonstrativa de crédito consignado'],
      ['Campo', 'Valor'],
      ['Capital', this.formatarMoeda(resultado.valorCapital)],
      ['Juros de carência', this.formatarMoeda(resultado.jurosCarencia)],
      ['Saldo após carência', this.formatarMoeda(resultado.saldoPosCarencia)],
      ['Parcela contratual', this.formatarMoeda(resultado.parcelaContrato)],
      ['Parcela recalculada', this.formatarMoeda(resultado.parcelaRecalculada)],
      ['Diferença mensal', this.formatarMoeda(resultado.diferencaMensal)],
      ['Diferença total nominal', this.formatarMoeda(resultado.diferencaTotal)],
      [],
      ['Parcela', 'Saldo inicial', 'Juros', 'Amortização', 'Parcela recalculada', 'Saldo final', 'Fator', 'Diferença']
    ];

    resultado.parcelas.forEach((p) => {
      linhas.push([
        String(p.numero),
        this.formatarNumero(p.saldoInicial, 2),
        this.formatarNumero(p.juros, 2),
        this.formatarNumero(p.amortizacao, 2),
        this.formatarNumero(p.parcela, 2),
        this.formatarNumero(p.saldoFinal, 2),
        this.formatarNumero(p.fator, 5),
        this.formatarNumero(p.diferencaParcela, 2)
      ]);
    });

    const csv = linhas.map((linha) => linha.map((valor) => `"${String(valor ?? '').replace(/"/g, '""')}"`).join(';')).join('\\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'memoria_consignado_demo.csv';
    a.click();
    window.URL.revokeObjectURL(url);
  }

  calcularDiasAtraso(dataVencimento: string, dataPagamento: string): number {
    if (!dataVencimento || !dataPagamento) return 0;

    const vencimento = new Date(`${dataVencimento}T00:00:00`);
    const pagamento = new Date(`${dataPagamento}T00:00:00`);
    const diff = pagamento.getTime() - vencimento.getTime();

    if (Number.isNaN(diff) || diff <= 0) return 0;

    return Math.ceil(diff / (1000 * 60 * 60 * 24));
  }

  formatarMoeda(valor: number): string {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor || 0);
  }

  formatarPercentual(valor: number): string {
    return `${(valor || 0).toFixed(4).replace('.', ',')}%`;
  }

  classeStatus(status: string): string {
    return status.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, '-');
  }
  subtipoConsignado?: string;
  valorLiberadoConsignado?: number;
  carenciaConsignado?: number;
  parcelasPagasConsignado?: number;
  competenciaBcbConsignado?: string;
  taxaMediaBcbConsignadoMensal?: number;
  taxaMediaBcbConsignadoAnual?: number;
  fonteBcbConsignado?: string;

}
